import React from 'react'
import { url } from 'utils'
import PropTypes from 'prop-types'

const Img = ({ src, ...props }) => (
  // eslint-disable-next-line jsx-a11y/alt-text
  <img src={url.appendVersion(src)} {...props} />
)

Img.propTypes = {
  src: PropTypes.string,
}

Img.defaultProps = {
  src: undefined,
}

export default Img
